import { Component } from '@angular/core';

import { user_local } from './Models/local_user';
import { Router , RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  user:string;
  view:boolean;
       constructor(public router:Router){
         this.user=localStorage.getItem('currant_user');
          if(this.user){
            this.view=true;            
          }
          else {
            this.view=false;
          }
       }
    title = 'app';


}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/app.component.ts